import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import type { Resource, Action } from '../../types/permissions';

interface PermissionGateProps {
  resource: Resource;
  action: Action;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const PermissionGate: React.FC<PermissionGateProps> = ({
  resource,
  action,
  children,
  fallback = null,
}) => {
  const { can } = usePermissions();
  return <>{can(resource, action) ? children : fallback}</>;
};

export default PermissionGate;
